"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecs = void 0;
const getSpecs = ({ specs }) => specs;
exports.getSpecs = getSpecs;
//# sourceMappingURL=get_specs.js.map